/**
 * @auth 赖传峰
 * @date 2022/5/17
 */

import { ElLoading } from 'element-plus'
import loadingSVGRaw from '~/assets/images/loading-24x24.svg?raw'

export default (args: Omit<Parameters<typeof ElLoading.service>[0], 'body' | 'spinner'> = {}) => {
  const loading = ElLoading.service({
    background: 'rgba(0,0,0,.9)',
    ...args,
    spinner: loadingSVGRaw,
    body: true,
  })
  ;(() => {
    const circular = Array.from(document.getElementsByClassName('circular')) as HTMLElement[]
    if (!circular.length) return
    circular.forEach(el => {
      el.setAttribute('viewBox', '0 0 24 24')

      el.style.height = '24px'

      el.style.width = '24px'
    })
  })()
  return loading
}
